import { useState } from 'react';

import { Button, CheckboxProps, Modal } from 'antd';
import { useApplyLeave } from '../../../context/ApplyLeaveContext';
import { DateRangePicker, RangeKeyDict } from "react-date-range";
import { Checkbox } from "antd";

import CalenderHeader from "./CalenderHeader";
import SingleMonth from "./SingleMonth";

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import "./userRangePicker.scss";
import MultipleMonth from './MultipleMonth';
type Props = {
  isVisible?: boolean;
  onClose: () => void;
  setFieldValue: any;
  values: any;
  resetForm: any;
  setShowDate: any;
  setDateErrorMessage: (valueType: string) => void;
  isTimeSubmit: Boolean;
  setIsTimeSubmit: (valueType: boolean) => void;
};

const CalenderModal = ({ values, setFieldValue, resetForm, setShowDate, setDateErrorMessage, isTimeSubmit, setIsTimeSubmit }: Props) => {
  const { modalOpen, handleCloseModal } = useApplyLeave()
  const [errorMessage, setErrorMessage] = useState('')
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [singleDate, setSingleDate] = useState(new Date())

  const handleSubmitModal = () => {
    const { leaveType, permissionStartTime, permissionEndTime } = values;
    setShowDate(true)
    if (leaveType === "2") {
      if (permissionStartTime && permissionEndTime) {
        setIsTimeSubmit(true);
        setErrorMessage('')
        setDateErrorMessage('')
        handleCloseModal();
      } else {
        if (!permissionStartTime || !permissionEndTime) {
          setErrorMessage("Start and End time are required");
        } else {
          setErrorMessage('')
        }
      }
    } else {
      setDateErrorMessage('')
      handleCloseModal();
    }
  };

  const handleCancelModal = () => {
    const { leaveType, permissionStartTime, permissionEndTime } = values;

    if (leaveType === "2") {
      if (!isTimeSubmit) {
        setFieldValue('permissionStartTime', null);
        setFieldValue('permissionEndTime', null);
      } else {
        setFieldValue('permissionStartTime', permissionStartTime);
        setFieldValue('permissionEndTime', permissionEndTime);
      }
      handleCloseModal();
    } else {
      handleCloseModal();
    }
  }

  return (
    <Modal className={`applyLeaveModal ${(values.leaveType === "2" || values.leaveType === "3") ? " h-auto" : " h-[95%] md:h-auto"} flex items-center justify-center`} open={modalOpen} onOk={handleSubmitModal} onCancel={handleCancelModal} width={900} footer={null}>
      <div className="bg-[#fff] flex justify-center items-center flex-wrap">

        <div className="w-full">
          <CalenderHeader date={selectionRange} values={values} resetForm={resetForm} />
        </div>
        <div className="w-full">
          {
            values.leaveType === "1" && (
              <MultipleMonth setDateErrorMessage={setDateErrorMessage} values={values} setFieldValue={setFieldValue} />
            )
          }
          {
            (values.leaveType === "2" || values.leaveType === "3") && (
              <SingleMonth
                setDateErrorMessage={setDateErrorMessage}
                setErrorMessage={setErrorMessage}
                values={values}
                dateRange={singleDate}
                setSingleDate={setSingleDate}
                setFieldValue={setFieldValue}
                errorMessage={errorMessage}
              />
            )
          }

        </div>
      </div>
      <div className="modal-footer pt-4 flex justify-end">
        <Button type="primary" shape="round" className='addButton w-[100px] lg:w-[120px]   _deprovision mr-4' onClick={handleCancelModal} >
          Cancel
        </Button>
        <Button className="w-[100px] lg:w-[120px]" type="primary" shape="round" size="large" htmlType="submit" onClick={handleSubmitModal} disabled={(values.leaveType === "2" || values.leaveType === "3") && (!values?.permissionStartTime || !values?.permissionEndTime)}
        >
          Done
        </Button>
      </div>
    </Modal>
  );
};

export default CalenderModal;
